import { tokens } from '@/config/tokens';
import { useDeposit } from '@/providers/DepositProvider';
import { i18n } from '@lingui/core';
import { Box, Card, Grid, Group, Image, Input, Stack, Text } from '@mantine/core';
import { useMemo } from 'react';
import { BuyCrypto } from '../BuyCrypto';
import { CopyWalletButton } from '../CopyWalletButton';
import { TokenMenuDropdown } from '../TokenMenuDropdown';
import classes from './Deposit.module.css';
import { DepositBalance } from './DepositBalance';
export const DepositTransaction: React.FC = () => {
  const {
    activeTab,
    setActiveTab
  } = useDeposit();
  const token = useMemo(() => tokens.find(item => item.symbol === activeTab), [activeTab]);
  return <Stack gap={20}>
      <Card radius={5} bg="var(--bg-600)" mt={20} p={{
      base: 10,
      sm: 20
    }} style={{
      overflow: 'visible'
    }}>
        <Grid gutter={{
        sm: 20,
        lg: 32
      }}>
          <Grid.Col span={{
          base: 12,
          sm: 8.5
        }} order={{
          base: 2,
          sm: 1
        }}>
            <Stack gap={10}>
              <Input size="md" rightSectionWidth={100} classNames={{
              input: classes.input
            }} value={`${token?.symbol} (${token?.name})`} style={{
              zIndex: 300
            }} rightSection={<TokenMenuDropdown logoURI={token?.logoURI} tokens={tokens} setActiveTab={setActiveTab} />} readOnly />

              <Group justify="space-between">
                <Text fz={13} c="var(--text-prime)" fw={500}>
                  {token?.description}
                </Text>
                <Text fz={13} c="var(--text-grey-4)" fw={500}>
                  {i18n._('6 confirmations')}
                </Text>
              </Group>
            </Stack>

            <Stack mt={40} gap={10}>
              <Text c="var(--text-dark)" fz={12} fw={700} tt="uppercase">
                {i18n._('Send')}
                <Text span inherit c="var(--text-prime)">
                  {` ${token?.name} (${token?.symbol}) `}
                </Text>
                {i18n._('to the following address')}
              </Text>

              <Group wrap="nowrap" justify="space-between" bg="var(--input-variant-color)" px={{
              base: 10,
              sm: 16
            }} py={12} h={40} style={{
              borderRadius: 5
            }}>
                <Box miw={300}>
                  <Text fz={13} fw={{
                  base: 500,
                  md: 700
                }} lts="5%" truncate="end">
                    {token?.address}
                  </Text>
                </Box>

                <CopyWalletButton value={`${token?.address}`} />
              </Group>

              <Box>
                <Text c="var(--icon-primary)" fz={13}>
                  {i18n._('Only deposit over the Ethereum network.')}
                </Text>
                <Text c="var(--icon-primary)" fz={13}>
                  {i18n._('Do not use BSC/BNB, Base, Arbitrum, Optimism or others.')}
                </Text>
              </Box>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{
          base: 12,
          sm: 3.5
        }} order={{
          base: 1,
          sm: 2
        }}>
            <Image src="/assets/wallet/qr_code.svg" w={{
            base: 160,
            sm: 171,
            lg: 218
          }} h={{
            base: 160,
            sm: 171,
            lg: 218
          }} mx="auto" style={{
            objectFit: 'contain'
          }} />
          </Grid.Col>
        </Grid>
      </Card>

      <DepositBalance tokenName={token?.symbol} />

      <BuyCrypto handleClick={() => setActiveTab('crypto')} />
    </Stack>;
};